import { useContext } from 'react';
import { CnFormArrayBaseItemContext } from '../context';
var takeRecord = function (val) { return (typeof val === 'function' ? val() : val); };
export var useRecord = function (record) {
    var ctx = useContext(CnFormArrayBaseItemContext);
    return takeRecord(ctx ? ctx.record : record);
};
